import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import './form.scss'
import templateUrl from './form.html'

/**
 * Item Configuration add/edit form component.
 *
 * @namespace tmrAdminItemConfigurationForm
 * @type {ngComponent}
 */
export const tmrAdminItemConfigurationForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminItemConfigurationFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminItemConfigurationForm}.
 *
 * @type {ngController}
 */
export class tmrAdminItemConfigurationFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    tmrIdentifierTypes
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { tmrIdentifierTypes })
  }

  $onInit() {
    this.types = Object.keys(this.tmrIdentifierTypes)
    this.identifiers = {}
    this.types.forEach(
      type =>
        (this.identifiers[type] =
          this.resource.identifiers.find(identifier => identifier.type === type)
            ?.amount ?? 0)
    )
    super.$onInit()
  }

  save() {
    this.resource.identifiers = this.types
      .filter(type => this.identifiers[type] > 0)
      .map(type => ({ type, amount: this.identifiers[type] }))
    super.save()
  }
}
